import { Button, Heading, Icon, Layout } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import CustomerPortalBox from "../../components/confirmationPage/CustomerPortalBox";
import { usePayments } from "../../hooks/usePayments";
import { useEffect } from "react";
import { trackOnSummaryFailed } from "../../adobeTracking/trackers";

export const ErrorPage = () => {
    const { handleTryAgain } = usePayments();
    const { t } = useTranslation("confirmationerrorpage");
    useEffect(() => {
        trackOnSummaryFailed();
    }, []);
    return (
        <>
            <Layout center>
                <Layout.Item default="1/3" s="1/1" className="u-text-center">
                    <Heading level={1}>{t("header")}</Heading>
                    <Icon name="semantic-close" className="u-mb-small" style={{ color: "#e4002c" }} />
                    <Heading level={2}>{t("subHeader")}</Heading>
                    <Button type="button" className="u-mb-small" onClick={() => handleTryAgain()}>
                        {t("tryAgainButton")}
                    </Button>
                    <p>{t("text")}</p>
                </Layout.Item>
            </Layout>

            <CustomerPortalBox />
        </>
    );
};
